<!-- Do not change this file. -->
<template>
  <div class="alert alert-danger d-flex justify-content-between">
    <div class="text-dark h4 fw-bold">Reset All User Data</div>
    <button class="btn btn-danger fw-bold" @click="clearData()">
      Reset All Data
    </button>
  </div>
</template>

<script>
/* Do not change this file. */

import DatastoreAPI from "@/helpers/DatastoreAPI";

export default {
  name: "AdminReset",
  mixins: [DatastoreAPI],
  methods: {
    clearData() {
      if (confirm("Reset all data?")) {
        this.deleteEntries(() => {
          this.readEntries();
        });
      }
    }
  }
};
</script>
